import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ModeOfContactService {

  constructor(private ws: PostmethodService) { }

  modeofContactCrud(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "modeOfContactMaster");
  }
}
